import Icon from '../components/Icon.vue'

Icon.register({
  globe: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M336.5 160h-177c14.5-89.3 48.7-152 88.5-152s74 62.7 88.5 152zM152 256c0-22.2 1.2-43.5 3.3-64h185.3c2.1 20.5 3.3 41.8 3.3 64s-1.2 43.5-3.3 64h-185.3c-2.1-20.5-3.3-41.8-3.3-64zM476.7 160h-108c-8.8-56.9-25.6-107.8-50-141.6 71.5 21.2 129.4 73.7 158 141.6zM177.2 18.4c-24.4 33.8-41.2 84.7-49.9 141.6h-108c28.5-67.9 86.5-120.4 157.9-141.6zM487.4 192c5.4 20.5 8.5 41.8 8.5 64s-3.1 43.5-8.6 64h-114.6c2.1-21 3.3-42.5 3.3-64s-1.2-43-3.3-64h114.7zM120 256c0 21.5 1.2 43 3.2 64h-114.6c-5.4-20.5-8.6-41.8-8.6-64s3.2-43.5 8.6-64h114.7c-2.1 21-3.3 42.5-3.3 64zM159.5 352h177c-14.5 89.3-48.7 152-88.5 152s-74-62.7-88.5-152zM318.8 493.6c24.4-33.8 41.2-84.7 50-141.6h108c-28.6 67.9-86.6 120.4-158 141.6zM19.3 352h108c8.8 56.9 25.6 107.8 50 141.6-71.5-21.2-129.4-73.7-158-141.6z'
      }
    ]
  }
})
